// Onboarding Pipeline: the routes and the sidebar rows of `wealth.onboarding.pipeline` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const NewEnquiryAction = lazy(() =>
    import('./pipeline.slots').then((m) => ({ default: m.NewEnquiryAction })),
);

const AmlCheckCard = lazy(() =>
    import('./pipeline.slots').then((m) => ({ default: m.AmlCheckCard })),
);

export default defineWebFeature({
    id: 'wealth.onboarding.pipeline',
    slots: {
        'desk.dashboard.actions': [{ key: 'new-enquiry', order: 10, Component: NewEnquiryAction }],
        // SEP-334. The cases that wait for the AML check, on the Ops Dashboard.
        // The card reads its cases inside its component, so the page cannot
        // count them: `count` is null, and the card never collapses and never
        // raises the hidden cue (SEP-296).
        'ops.dashboard.cards': [
            {
                key: 'aml-check',
                order: 10,
                span: 6,
                title: 'Ready for the AML check',
                summary: 'The onboarding cases that wait for the AML check of Operations.',
                rows: 5,
                count: () => null,
                emptyBehaviour: 'keep',
                Component: AmlCheckCard,
            },
        ],
    },
    routes: [
        {
            frontend: 'desk',
            path: 'onboarding',
            lazy: () => import('@/pages/desk/onboarding/page'),
        },
        {
            frontend: 'desk',
            path: 'onboarding/analytics',
            lazy: () => import('@/pages/desk/onboarding/analytics/page'),
        },
        {
            frontend: 'desk',
            path: 'onboarding/case/:caseId',
            lazy: () => import('@/pages/desk/onboarding/case/page'),
        },
        {
            frontend: 'desk',
            path: 'onboarding/case/:caseId/client-application',
            lazy: () => import('@/pages/desk/onboarding/client-application/page'),
        },
        { frontend: 'ops', path: 'onboarding', lazy: () => import('@/pages/ops/onboarding/page') },
        {
            frontend: 'ops',
            path: 'onboarding/analytics',
            lazy: () => import('@/pages/ops/onboarding/analytics/page'),
        },
        {
            frontend: 'ops',
            path: 'onboarding/case/:caseId',
            lazy: () => import('@/pages/ops/onboarding/case/page'),
        },
        {
            frontend: 'ops',
            path: 'onboarding/case/:caseId/client-application',
            lazy: () => import('@/pages/ops/onboarding/client-application/page'),
        },
        {
            frontend: 'comply',
            path: 'onboarding',
            lazy: () => import('@/pages/comply/onboarding/page'),
        },
        {
            frontend: 'comply',
            path: 'onboarding/analytics',
            lazy: () => import('@/pages/comply/onboarding/analytics/page'),
        },
        {
            frontend: 'comply',
            path: 'onboarding/case/:caseId',
            lazy: () => import('@/pages/comply/onboarding/case/page'),
        },
        {
            frontend: 'comply',
            path: 'onboarding/case/:caseId/client-application',
            lazy: () => import('@/pages/comply/onboarding/client-application/page'),
        },
        {
            frontend: 'view',
            path: 'onboarding',
            lazy: () => import('@/pages/view/onboarding/page'),
        },
        {
            frontend: 'view',
            path: 'onboarding/analytics',
            lazy: () => import('@/pages/view/onboarding/analytics/page'),
        },
        {
            frontend: 'view',
            path: 'onboarding/case/:caseId',
            lazy: () => import('@/pages/view/onboarding/case/page'),
        },
        {
            frontend: 'view',
            path: 'onboarding/case/:caseId/client-application',
            lazy: () => import('@/pages/view/onboarding/client-application/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'onboarding',
            label: 'Onboarding Pipeline',
            href: '/comply/onboarding',
            icon: 'Rocket',
            group: 'clients-kyc',
            order: 310,
        },
        // --- Septima CRM ---
        {
            frontend: 'desk',
            key: 'onboarding',
            label: 'My Onboarding',
            href: '/desk/onboarding',
            icon: 'Rocket',
            group: 'septima-crm',
            order: 210,
        },
        {
            frontend: 'ops',
            key: 'onboarding',
            label: 'Onboarding Pipeline',
            href: '/ops/onboarding',
            icon: 'Rocket',
            group: 'client-operations',
            order: 410,
        },
        {
            frontend: 'view',
            key: 'onboarding',
            label: 'Onboarding Pipeline',
            href: '/view/onboarding',
            icon: 'Rocket',
            group: 'clients-risk',
            order: 420,
        },
    ],
});
